//Reducers can be viewed simply as functions that return some data. All these small pieces of data can be used in App wherever required by importing respective Reducers.
// The customers got moved to global! This just sadly handles the load

const initialState = {
	list: [],
	customersLoading: false,
	suppliersLoading: false
};

export default function (state: any = initialState, action: Function) {
	if (action.type === 'CUSTOMERS_IS_LOADING') {
		return {
			...state,
			customersLoading: action.isLoading
		};
	}
	if (action.type === 'SUPPLIERS_IS_LOADING') {
		return {
			...state,
			suppliersLoading: action.isLoading
		};
	}
	/*
	--- this is in globalReducer now
	if (action.type === 'CUSTOMERS_LIST_SUCCESS') {
		console.log('CUSTOMERS_LIST_SUCCESS');
		/*var customers = action.list;
		customers.forEach(function(customer, i, theCustomers){
			theCustomers[i].display = customer.businessName?customer.businessName:customer.name;
		});*

		return {
			...state,
			list: action.list
		};
	}*/
	return state;
}

/*
In case an Action is dispatched from any point in the App, the action will be sent to all Reducers that we have created.

var gitRepos= [];
export default function(state=gitRepos, action){
  switch (action.type) {
    case "Get_Repos": { gitRepos = action.payload;
      console.log(action, 'action');
      return gitRepos;
    }
    break;
  }
  return gitRepos;
}*/
